import { render, staticRenderFns } from "./NumberAddressModal.vue?vue&type=template&id=6412d38c&"
import script from "./NumberAddressModal.vue?vue&type=script&lang=js&"
export * from "./NumberAddressModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports